// src/api/loginApi.js

import { toast } from 'sonner';
import axiosInstance from './axiosInstance';

export const userLogin = (email, password) => {
  return axiosInstance
    .post('/auth/login', { email, password })
    .then((response) => {
      localStorage.setItem('token', response.data.token);
    })
    .catch((error) => {
      console.error('Error logging in:', error);
      throw error.response;
    });
};

export const userForgotPassword = (email) => {
  return axiosInstance
    .post('/auth/forgot-password', { email })
    .then((response) => {
      return response.data;
    });
};

export const userResetPassword = (email, otp, password) => {
  return axiosInstance
    .post('/auth/reset-password', { email, otp, password })
    .then((response) => {
      return response.data;
    });
};

export const verifyUserOtp = (email, otp) => {
  return axiosInstance
    .post('/auth/verify-otp', { email, otp })
    .then((response) => {
      return response.data;
    });
};

export const userUpdatePassword = (email, oldPassword, newPassword) => {
  return axiosInstance
    .post('/auth/update-password', { email, oldPassword, newPassword })
    .then((response) => {
      localStorage.setItem('token', response.data.token);
    })
    .catch((error) => {
      console.error('Error logging in:', error);
      throw error.response;
    });
};
